import { GridTabs } from '@ihsm/ui-shared';
import React from 'react';
import { ViewControls } from 'shared/components/ViewControls';
import { ViewSelector } from 'shared/components/ViewSelector';
import {
  LEVEL_TAB,
  MARKET_DATA_VIEW_OPTION_LIST,
  RETURN_TAB,
} from '../../constants';

export interface ViewControlsContainerProps {
  assetClassType: string;
  onChartChange: (value: string) => void;
  selectedViewOptions: string[];
  setSelectedViewOptions: (values: string[]) => void;
}

export const ViewControlsContainer: React.FC<ViewControlsContainerProps> = ({
  assetClassType,
  onChartChange,
  selectedViewOptions,
  setSelectedViewOptions,
}) => (
  <ViewControls showTitle={false}>
    <GridTabs
      activeTab={assetClassType}
      tabs={[LEVEL_TAB, RETURN_TAB]}
      disabledTabs={[]}
      onChange={onChartChange}
    />
    <ViewSelector
      selectedValues={selectedViewOptions}
      options={MARKET_DATA_VIEW_OPTION_LIST}
      onChange={setSelectedViewOptions}
    />
  </ViewControls>
);
